<script>
export default {
  name: "ReportCashflow",
  permissions: ["Administer Bend Workflow"],
  data: function () {
    return {
      expenses: "",
      bankBalance: "",
    }
  },
  methods: {
    generateCashflow() {
      this.$BwfApi.post(`capacity-plan/cashflow`, {
        expenses: this.expenses,
        bank_balance: this.bankBalance
      }, {responseType: "blob"})
          .then(response => {
            const objectUrl = window.URL.createObjectURL(response)
            const anchor = document.createElement("a")
            document.body.appendChild(anchor)
            anchor.target = "_blank"
            anchor.href = objectUrl
            anchor.click()
          })
    }
  }
}
</script>

<template>
  <v-card class="mb-5">
    <v-card-title>Generate Cashflow Report</v-card-title>
    <v-card-text>
      <v-textarea
          label="Expenses"
          v-model="expenses"
      ></v-textarea>
      <p>Optionally, paste in the expenses totals row from the expenses sheet. Select the whole row and copy and
        paste.</p>
      <p>This should have the alternating columns of Month Name and Total. eg. Apr | 20000 | May | 10000 ....</p>
      <v-text-field
          label="Bank Balance"
          v-model="bankBalance"
          type="number"
      ></v-text-field>
      <v-btn @click="generateCashflow" color="primary" class="mb-5">Generate Cashflow Report</v-btn>
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>